import { sortByDistance } from "./sort-by-distance.js";
const findNearestCoordinates = (reference, items, options = { limit: 1 }) => sortByDistance(reference, items).slice(0, options.limit).map(([item, distance]) => ({ ...item, distance }));
export {
  findNearestCoordinates
};
//# sourceMappingURL=find-nearest-coordinates.js.map
